import { defineComponent as _defineComponent } from 'vue'
import adminMenu from "@/components/admin/menu/menu";
import clientQuoteMenu from "@/components/client/menu/client-quote-menu";
import clientCapMenu from "@/components/client/menu/client-cap-menu";
import Sidebar from "@/components/molecules/sidebar/Sidebar.vue";
import { getCurrentInstance, onMounted, reactive, ref, watch, computed } from 'vue';

interface AppMenuState {
    isAuthenticated: boolean;
    isRouteAdmin: boolean;
    business: {
        id: string;
        name: string;
        type_id: number;
        ownerFirstName?: string;
        ownerLastName?: string;
        email?: string;
    };
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenu',
  setup(__props) {

const state = reactive<AppMenuState>({
    isAuthenticated: false,
    isRouteAdmin: false,
    business: {
        id: '',
        name: '',
        type_id: 0,
    },
    isLoading: false,
});

const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;

const currentRoute = ref<string>(proxy.$route.fullPath || '/');

watch(() => proxy.$route.fullPath, async (fullPath) => {
    if (fullPath) {
        currentRoute.value = fullPath;
        await authValidation();
    }
});

const loadBusiness = async () => {
    state.isLoading = true;
    try {
        const response: any = await proxy.$root._get(`businesses/one/${proxy.$store.state.user.businessId}`);
        state.business = response.data;
        proxy.$store.commit("setBusiness", response.data);
    } catch (e) {
        console.log(e);
    } finally {
        state.isLoading = false;
    }
};

const getClientMenu = () => {
    switch (state.business.type_id) {
        case 2:
            return clientQuoteMenu;
        case 1:
        default:
            return clientCapMenu;
    }
};

const links = computed(() => state.isRouteAdmin ? adminMenu : getClientMenu());

const getCurrentRoute = () => {
    return currentRoute.value;
};

const authValidation = async () => {
    const fullRoute: string = getCurrentRoute();
    const currentRouteParts: string[] = fullRoute.split("/");
    state.isAuthenticated = proxy.isLoggedIn && await proxy.isLoggedIn();
    state.isRouteAdmin = currentRouteParts[1] === "admin";
};

onMounted(async () => {
    await authValidation();
    if (!state.isRouteAdmin) {
        await loadBusiness();
    } else {
        proxy.$store.commit("setBusiness", proxy.$store.state.user.business_type_id);
    }
});

return { __sfc: true,state, instance, proxy, currentRoute, loadBusiness, getClientMenu, links, getCurrentRoute, authValidation, Sidebar }
}

})